/* UpHold product section behaviour. Loaded by sections/uphold_product.liquid.
   Config comes from window.UPHOLD_CFG, set inline in the section. */
(function(){
  var CFG = window.UPHOLD_CFG || {};
  var uid = CFG.uid;
  if (!uid) return;
  var root = document.getElementById('up-' + uid);
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  if (root.dataset.hideHeader === 'true') {
    var mine = root.closest('.shopify-section') || root;
    var sels = ['#shopify-section-header','.shopify-section-group-header-group',
                'header.header','.site-header','.header-wrapper','.section-header'];
    for (var a = 0; a < sels.length; a++){
      var found = document.querySelectorAll(sels[a]);
      for (var b = 0; b < found.length; b++){
        var n = found[b];
        if (n === mine || n.contains(mine) || n.contains(root)) continue;
        n.style.display = 'none';
      }
    }
  }

  var mainImg = document.getElementById('up-main-' + uid);
  var thumbs  = root.querySelectorAll('.up-thumb');
  for (var t = 0; t < thumbs.length; t++){
    thumbs[t].addEventListener('click', function(){
      if (!mainImg) return;
      mainImg.src = this.dataset.src;
      for (var k = 0; k < thumbs.length; k++){ thumbs[k].setAttribute('aria-current','false'); }
      this.setAttribute('aria-current','true');
    });
  }

  /* ---- gallery arrows -----------------------------------------------------
     Created here rather than in the section markup on purpose: they do nothing
     without JS, and a dead button is worse than no button. They step through
     the thumbnails and fire the handler above, so the main image, the
     aria-current state and the scroll strip all stay in sync with each other.
     Styles live in snippets/uphold-video-css.liquid (.up-gnav). */
  if (mainImg && thumbs.length > 1){
    var hero = mainImg.parentNode;
    var PATHS = { prev: 'M15 18l-6-6 6-6', next: 'M9 6l6 6-6 6' };
    var makeArrow = function(dir, label){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'up-gnav up-gnav-' + dir;
      btn.setAttribute('aria-label', label);
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + PATHS[dir] + '"/></svg>';
      return btn;
    };
    var step = function(delta){
      var cur = 0;
      for (var i = 0; i < thumbs.length; i++){
        if (thumbs[i].getAttribute('aria-current') === 'true'){ cur = i; break; }
      }
      var n = thumbs.length;
      var target = ((cur + delta) % n + n) % n;
      thumbs[target].click();
      if (thumbs[target].scrollIntoView){
        thumbs[target].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    };
    var prevBtn = makeArrow('prev', 'Previous image');
    var nextBtn = makeArrow('next', 'Next image');
    prevBtn.addEventListener('click', function(){ step(-1); });
    nextBtn.addEventListener('click', function(){ step(1); });
    hero.appendChild(prevBtn);
    hero.appendChild(nextBtn);
  }

  var el = root.querySelector('[data-count]');
  if (el){
    var from = parseFloat(el.dataset.from), to = parseFloat(el.dataset.to);
    var sfx = el.dataset.suffix || '', dur = parseInt(el.dataset.duration,10) || 1600;
    if (!isNaN(from) && !isNaN(to)){
      var paint = function(x){ el.textContent = Math.round(x) + sfx; };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window) || !window.requestAnimationFrame){
        paint(to);
      } else {
        paint(from);
        var go = false;
        var run = function(){
          if (go) return; go = true;
          var t0 = null;
          var frame = function(ts){
            if (t0 === null) t0 = ts;
            var p = (ts - t0) / dur; if (p > 1) p = 1;
            paint(from + (to - from) * (1 - Math.pow(1 - p, 3)));
            if (p < 1) window.requestAnimationFrame(frame);
          };
          window.requestAnimationFrame(frame);
        };
        var io = new IntersectionObserver(function(en){
          for (var i=0;i<en.length;i++){ if(en[i].isIntersecting){ run(); io.disconnect(); break; } }
        }, { threshold: 0.5 });
        io.observe(el);
      }
    }
  }

  var variants = CFG.variants || [];
  var radios   = root.querySelectorAll('input[type="radio"][data-optidx]');
  var idField  = document.getElementById('up-varid-' + uid);
  var priceEl  = document.getElementById('up-price-' + uid);
  var cmpEl    = document.getElementById('up-compare-' + uid);
  var atc      = document.getElementById('up-atc-' + uid);
  if (!radios.length || !idField || !atc) return;

  var FMT = CFG.moneyFormat || '${{amount}}';
  var TOKEN = new RegExp('\\{\\{\\s*(amount(?:_no_decimals)?(?:_with_comma_separator)?(?:_no_decimals_with_comma_separator)?)\\s*\\}\\}');

  function money(cents){
    var dollars = cents / 100;
    return FMT.replace(TOKEN, function(_, token){
      if (token === 'amount') return dollars.toFixed(2);
      if (token === 'amount_no_decimals') return String(Math.round(dollars));
      if (token === 'amount_with_comma_separator') return dollars.toFixed(2).replace('.', ',');
      return String(Math.round(dollars));
    });
  }

  function sized(url, w){
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function chosen(){
    var out = [];
    for (var i = 0; i < radios.length; i++){
      if (radios[i].checked) out[parseInt(radios[i].dataset.optidx,10)] = radios[i].value;
    }
    return out;
  }
  function match(sel){
    for (var i = 0; i < variants.length; i++){
      var vr = variants[i], ok = true;
      for (var j = 0; j < sel.length; j++){
        if (sel[j] !== undefined && vr.options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return vr;
    }
    return null;
  }

  /* ---- sold-out colour options -------------------------------------------
     The section markup loops over option.values, which are plain strings, so
     it has no idea which colours are actually in stock — every pill renders
     identically. The stock data does reach the page, but only as JSON in
     window.UPHOLD_CFG.variants, so the sold-out state has to be stamped on
     here rather than styled from CSS alone.

     What this does, per pill:
       • sets data-soldout="true|false" on the wrapping label, which is the
         only hook snippets/uphold-video-css.liquid has to grey it out
       • sets the radio's disabled property, so the pill cannot be picked at
         all — not merely styled as if it can't be

     Availability comes from Shopify, not from a hardcoded list here. A colour
     greys out when its variant is out of stock AND set to "stop selling when
     out of stock"; restock it in the admin and the pill comes back on its own
     with nothing to change in this file. If a colour you expect to be sold out
     still looks selectable, check its inventory POLICY in the admin — on
     "continue selling" Shopify reports it as available and this is correct to
     leave it enabled. */
  function labelFor(radio){
    if (radio.closest) return radio.closest('.up-opt');
    return radio.parentNode;
  }
  function variantFor(radio){
    var sel = chosen();
    sel[parseInt(radio.dataset.optidx, 10)] = radio.value;
    return match(sel);
  }
  function paintOptions(){
    for (var i = 0; i < radios.length; i++){
      var vr  = variantFor(radios[i]);
      var out = !vr || !vr.available;
      var lab = labelFor(radios[i]);
      if (lab) lab.setAttribute('data-soldout', out ? 'true' : 'false');
      radios[i].disabled = out;
    }
  }
  /* If the server pre-selected a colour that is now sold out, move the
     selection to the first colour that is actually buyable, so nobody lands on
     a dead "Sold out" button and assumes the whole product is gone. */
  function pickAvailable(){
    var cur = match(chosen());
    if (cur && cur.available) return;
    for (var i = 0; i < radios.length; i++){
      var vr = variantFor(radios[i]);
      if (vr && vr.available){ radios[i].checked = true; return; }
    }
  }

  function update(){
    var vr = match(chosen());
    if (!vr){ atc.disabled = true; atc.textContent = 'Unavailable'; return; }
    idField.value = vr.id;
    if (priceEl) priceEl.textContent = money(vr.price);
    if (cmpEl){
      if (vr.compare_at_price && vr.compare_at_price > vr.price){
        cmpEl.textContent = money(vr.compare_at_price);
        cmpEl.style.display = '';
      } else { cmpEl.style.display = 'none'; }
    }
    atc.disabled = !vr.available;
    atc.textContent = vr.available ? 'Add to cart' : 'Sold out';
    if (mainImg && vr.featured_image && vr.featured_image.src){
      mainImg.src = sized(vr.featured_image.src, 1200);
      for (var q = 0; q < thumbs.length; q++){ thumbs[q].setAttribute('aria-current','false'); }
    }
  }
  for (var r = 0; r < radios.length; r++){
    radios[r].addEventListener('change', function(){ update(); paintOptions(); });
  }
  pickAvailable();
  update();
  paintOptions();
})();
